import { useEffect, useState } from 'react';
import { ContactLinks } from './ContactLinks';
import { LOCALES, useI18n } from '@/i18n';
import { Link, ROUTES, useRouter } from '@/router';
import { Logo } from './Logo';

export function Arrow({ dir = 'ne' }: { dir?: 'ne' | 'e' }) {
  return (
    <svg viewBox="0 0 16 16" className="arrow" aria-hidden="true">
      {dir === 'ne' ? <path d="M4.5 11.5 11.5 4.5M5.5 4.5h6v6" /> : <path d="M3 8h10M9 4l4 4-4 4" />}
    </svg>
  );
}

export function Header() {
  const { d, locale, setLocale } = useI18n();
  const { path } = useRouter();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [path]);

  const nav = [
    { to: '/#printing', label: d.nav.printing },
    { to: '/#products', label: d.nav.products },
    { to: '/#portfolio', label: d.nav.portfolio },
    { to: '/#b2b', label: d.nav.b2b },
    { to: '/#contact', label: d.nav.contact },
  ];

  return (
    <header className={`site-header${open ? ' is-open' : ''}`}>
      <div className="site-header__in wrap">
        <Link to="/" className="site-header__logo">
          <Logo />
        </Link>
        <nav className="site-nav" aria-label="main">
          {nav.map((n) => (
            <Link key={n.to} to={n.to}>
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="site-header__tools">
          <div className="lang" role="group" aria-label={d.nav.languageSoon} title={d.nav.languageSoon}>
            {LOCALES.filter((l) => l.enabled).map((l) => (
              <button key={l.id} type="button" aria-pressed={l.id === locale} onClick={() => setLocale(l.id)}>
                {l.short}
              </button>
            ))}
          </div>
          <Link to={ROUTES.candleConfigurator} className="btn btn--dark btn--sm site-header__cta">
            {d.nav.configurator} <Arrow />
          </Link>
          <button type="button" className="burger" aria-expanded={open} aria-controls="mobile-nav" onClick={() => setOpen((v) => !v)}>
            <span className="visually-hidden">{d.nav.menu}</span>
            <span aria-hidden="true" />
          </button>
        </div>
      </div>
      <nav id="mobile-nav" className="mobile-nav" hidden={!open} aria-label="mobile">
        {nav.map((n) => (
          <Link key={n.to} to={n.to} onClick={() => setOpen(false)}>
            {n.label}
          </Link>
        ))}
        <Link to={ROUTES.candleConfigurator} className="btn btn--primary">
          {d.nav.configurator} <Arrow dir="e" />
        </Link>
      </nav>
    </header>
  );
}

export function Footer() {
  const { d } = useI18n();
  return (
    <footer className="site-footer">
      <div className="wrap site-footer__in">
        <div className="site-footer__brand">
          <Logo inverse />
          <p className="site-footer__claim">Digital Decoration.<br />Made Personal.</p>
        </div>
        <div className="site-footer__cols">
          <div>
            <p className="kicker">{d.nav.contact}</p>
            <ContactLinks className="contact-links--footer" />
          </div>
          <div>
            <p className="kicker">{d.nav.products}</p>
            <Link to={ROUTES.candleConfigurator}>{d.nav.configurator}</Link>
            <Link to="/#products">{d.products.title}</Link>
            <Link to="/#portfolio">{d.portfolio.title}</Link>
          </div>
        </div>
        <p className="site-footer__legal">{d.footer.rights.replace('{y}', String(new Date().getFullYear()))}</p>
      </div>
    </footer>
  );
}
